/** The small caps label over each section of the underwriting header (Recent Revenue, Decision, ...). */
export const HEADER_LABEL =
  "mb-0.5 text-[0.62rem] font-semibold uppercase tracking-wide text-muted-foreground/70";

/**
 * A pane of the header's decision card: at least 7rem tall and filling the row's height, so
 * Approve / Decline sit centred at their own height while a status block fills the pane.
 */
export const HEADER_PANE = "relative flex min-h-28 flex-col px-3 py-3";
